import styled from 'styled-components';
import Destinations from './Destinations';
import { colorSchema, media } from 'utils/style';

export default styled(Destinations)`
  .destinations {
    display: flex;
    flex-basis: 78%;

    &__from,
    &__to {
      width: 230px;
    }

    &__time {
      margin-bottom: 0.5rem;
    }

    &__localization {
      color: ${colorSchema('grey900')};
      font-weight: bold;
    }

    &__arrow {
      align-items: center;
      display: flex;
      padding: 0 1.6rem;

      ${media.greaterThan('tablet')`
        flex-basis: 2%;
        margin: 0;
      `}

      svg {
        fill: ${colorSchema('grey500')};
        height: 16px;
        transform: rotate(90deg);
        width: 16px;
      }
    }

    &__stops {
      width: 100px;
      padding: 0 1.6rem;
      display: flex;
      flex-flow: column-reverse;
    }

    &__distance {
      color: ${colorSchema('grey900')};
      margin-top: 0.5rem;
    }

    &__stops-number {
      color: ${colorSchema('grey700')};
      font-size: 1.5rem;
    }
  }
`;
